import * as Sentry from '@sentry/react';

// Compatible Vite (import.meta.env) et Jest (process.env)
const isDev = typeof process !== 'undefined' && process.env.NODE_ENV === 'development';
const isSentryEnabled = typeof process !== 'undefined' && Boolean(process.env.VITE_SENTRY_DSN);

export const logger = {
  log: (message, context = {}) => {
    if (isDev) {
      console.log(`[INFO] ${message}`, context);
    } else if (isSentryEnabled) {
      Sentry.captureMessage(message, { level: 'info', extra: context });
    }
  },

  warn: (message, context = {}) => {
    if (isDev) {
      console.warn(`[WARN] ${message}`, context);
    } else if (isSentryEnabled) {
      Sentry.captureMessage(message, { level: 'warning', extra: context });
    }
  },

  error: (error, context = {}) => {
    if (isDev) {
      console.error(`[ERROR]`, error, context);
    } else if (isSentryEnabled) {
      Sentry.captureException(error, { extra: context });
    }
  },
};
